import React, { createContext, useEffect, useState } from 'react';
import { getLoggedInUserWithTtl } from '../misc';
import { navigate } from 'gatsby';

interface AuthContextType {
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
};


export const AuthContext = createContext<AuthContextType>({
  isLoggedIn: false,
  setIsLoggedIn: () => { },
});


export const AuthProvider = ({ children }: { children: any }) => {
  let skipLogin: boolean = false;

  if (typeof window !== `undefined` && children) {
    const prodOrigin = 'https://nordisketax.net';
    const localOrigin = 'http://localhost:8000';
    skipLogin = children.props.location.origin === prodOrigin || (localOrigin && children.props.location.origin === localOrigin);
  }

  const [isLoggedIn, setIsLoggedIn] = useState(skipLogin ? skipLogin : getLoggedInUserWithTtl('isLoggedIn'));


  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login/')
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!skipLogin) {
      setIsLoggedIn(getLoggedInUserWithTtl('isLoggedIn'));
    }
  }, [skipLogin, children]);

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};
